import React from "react";
import './FundoSite.css'
import Logo from '../campos/imagens/Logo-10D-2022.png';

function FundoSite(){
    return(
        <div className="cp4">
            <div className="cp3">
                <div className="cp2">
                    <div className="cp1">
                        <div className="dpInit">
                            <div className="camplogo">
                                {/* imagem de logo */}
                                <img className="logoImg" src={Logo} alt=""/>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    )
}
export default FundoSite;